import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import {AlightStateType}  from '../../types/alight-state';
import { Store } from 'redux';
import { sendRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import {EntryOriginTypesV5} from '@alme/api-ts/Alme/EntryOriginTypes';
import { OfferData } from "../../types/offer-data";
import { traceLog } from "../../src/logging";
import * as Actions from './actions/actions';

export default class LaunchOffersEventUtility
{
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | null = null;

    constructor(passedSettings: AlightCustomSettingsType)
    {
        this._settings = passedSettings;
    }


    initialize(store: Store<AlightStateType>): void
    {
        this._store = store;
    }

    sendLaunchOfferAppEvent(offerName: string): void{
        if(this._settings.AppEvents.launchOfferTypes.includes(offerName))
        {
            const parameters = this.GenerateParameters(offerName);
            if(parameters != null){
                this.debugMessage('Marking offer as provided.');
                this._store?.dispatch(Actions.markOfferProvided(offerName));

                const input = {
                    messageType: this._settings.messageConstants.appeventRequest,
                    eventName: offerName,
                    origin: this._settings.originConstants.internal as EntryOriginTypesV5,
                    parameters: parameters,
                };
                this.debugMessage(`Sending launch offer request. ${JSON.stringify(input)}`);
                sendRequest(input);

                this.debugMessage('Removing Offer Data from State');
                this._store?.dispatch(Actions.removeOfferData(offerName));
            }
            else{
                    console.error("Missing Offer Record");
            }  
        }
        else{
            console.error("Invalid Offer Type");
        } 
    }


    GenerateParameters(offerName: string): { AvailableOffers: string; AssistTicketData?: undefined } 
    | { AssistTicketData: string; AvailableOffers?: undefined } | null | undefined{
        if(this._store){
            const state = this._store?.getState() || [];

            const offersData = state?.Offers?.OfferData;
            const objIndex = offersData?.findIndex(((obj: OfferData) => obj.OfferType == offerName));
            if(objIndex > -1){
                const data = offersData[objIndex].Data || "";

                if(data !== ""){
                    return this.GenerateParametersFromData(offerName, data);
                }
                else{
                    console.error("Missing Data for AppEvent");
                }
            }

            return null;
        }
    }

    GenerateParametersFromData(offerName: string, offerData: string): { AvailableOffers: string; AssistTicketData?: undefined } 
    |{ AssistTicketData: string; AvailableOffers?: undefined } | undefined{
        if(offerName === "HypeOffer"){
            return {
                AvailableOffers: offerData,
            };
        }
        
        if(offerName === "AssistTicketUpdate"){
            return {
                AssistTicketData: offerData,
            };
        }
    }

    debugMessage(message: string): void{
        if (process.env.NODE_ENV !== 'production'){
            traceLog(message, 'LaunchOffersAppEventUtility');
        }
    }
}



// WEBPACK FOOTER //
// ./modules/launch-offers-appevent-utility/launchOffersAppEventUtility.ts